export default __webpack_public_path__ + "static/media/list_checked.0bda8336.svg";